import LegalPageLayout from "@/components/legal/LegalPageLayout";
import { cguvContent } from "@/data/legal/cguvContent";

export default function CGUVPage() {
  return <LegalPageLayout content={cguvContent} testId="cguv-page" />;
}
